import '../../style/index.less';
import './index.less';

// style dependencies
// deps-lint-skip: layout
import '../../tooltip/style';
